export default __webpack_public_path__ + "static/media/ico-mongodb-score-elevated.8d041584.svg";